
<template>
  <div class="tf-vue-bg-grey-darker">
    <a href="javascript:void(0)" class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 p-2" data-bs-toggle="modal" data-bs-target="#winterModal">
      <!-- fix class above for tf express '?' styling -->
      <span class="icon-information"></span>
    </a>
  
    <div 
      id="winterModal"
      class="modal"
      tabindex="-1"
      aria-labelledby="winterModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content p-4">
          <!-- WINTER SPORTS -->
      <div class="container" v-if="quoteType !== 'BACKPACKER'">
          <div>
            <h4 class="text-center text-dark">Add Winter Sports Cover</h4>
          </div>
          <div>
            <p class="text-dark fw-bold">
              If you wish to participate in winter sport activities you can add the additional cover to your policy 
              for a maximum of 28 days. You do not have to specify the days you intend to do winter sports nor do the 
              days have to be consecutive. See Section H of the 
              <a class="text-dark text-decoration-none fw-bolder" :href="'/travel-insurance/' + policy">Policy Document</a> for full details.
            </p>
          </div>
      </div>
      <!-- BACKPACKER SPORTS -->
      <div v-else class="container">
        <div>
            <h4 class="text-center text-dark">Includes claims for:</h4>
          </div>
      <ul>
        <li>Unused pre-paid ski passes, ski hire or tuition fees which the insured person is not able to participate in because of ill health or injury.</li>
        <li>Damaged or lost equipment, such as skis.</li>
        <li>The cost of hiring temporary replacement skis.</li>
        <li>Transport costs to get to a different resort if prebooked resort piste is closed due to lack of snow.</li>
        <br/>
        <p>Maximum 28 days cover which does not need to be consecutive.</p>
        <p>Medical expenses and personal liability claims related to recreational sporting activities are included as standard without the need to pay an additional premium.</p>
        <small><em>See Section I of the policy document for full details.</em></small>
      </ul>
      </div>

      

      <div class="text-center my-5">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
      </div>  
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ['policy', 'quoteType'],
  data() {
    return {
      modalShow: false,
    }
  },
  computed: {
    title() {
      if(this.quoteType === 'SINGLEG') {
        return 'Single Trip Insurance'
      } else {
        return 'Annual Multi-Trip'
      }
    },
  },
  methods: {
    hideModal() {
      this.modalShow = false
    },
  }
}
</script>
<style scoped>

  .container {
    width: 100%;
  }
</style>